import React from 'react';
import {
  PlayersInner
} from './final.js';

class GamePlayers extends React.Component {
  LABELS = { MIXT: "Участники" };
  MESSAGES = { MIXT: "На игру пока никто не записан" };

  label = () => {
    return this.LABELS.MIXT;
  }

  message = () => {
    return this.MESSAGES.MIXT;
  }

  players = () => {
    return (
      <PlayersInner
        label={this.label()}
        message={this.message()}
        players={this.props.game.players}
        totalPlayersNum={this.props.game.totalPlayersNum}
        numberOfPlayers={this.props.game.numberOfPlayers}
        playersCount={true}
        flag={""}
        gameType={this.props.game.gameType}
      />
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.players()}
      </React.Fragment>
    )
  }
}

export default GamePlayers;
